export const FETCH_SECTION = 'FETCH_SECTION';
export const FETCH_SECTION_SUCCESS = 'FETCH_SECTION_SUCCESS';

export const fetchSection = (section: string) => ({
  type: FETCH_SECTION,
  section,
});

export const fetchSectionSuccess = (section: string) => ({
  type: FETCH_SECTION_SUCCESS,
  section,
});
